export interface TicketTag {
  _id: string
  description: string
  color?: string
  organization?: string
}

export const useTicketTagStore = defineStore(`ticket-tag`, () => {
  const getTicketTags = async (pagination = false, organizationQuery?: Record<string, unknown> | string) =>
    useCrudMethods<TicketTag>("/ticket-tags").readItems({
      query: JSON.stringify({ organization: organizationQuery }),
      pagination,
      sort: JSON.stringify({ description: "asc" }),
    })
  const updateTicketTag = async (id: TicketTag["_id"], item: Partial<TicketTag>) =>
    useCrudMethods<TicketTag>("/ticket-tags").updateItem(id, item)
  const createTicketTag = async (item: Partial<TicketTag>) => useCrudMethods<TicketTag>("/ticket-tags").createItem(item)
  const deleteTicketTag = async (id: TicketTag["_id"]) => useCrudMethods<TicketTag>("/ticket-tags").deleteItem(id)

  const getTicketTagCount = async (organization?: string): Promise<Array<CountAggregate>> => {
    const { data } = await useSamApi<Array<CountAggregate>>(
      `/ticket-tags/ticket-count${organization ? `?organization=${organization}` : ""}`,
    )
    return data
  }

  return {
    getTicketTags,
    updateTicketTag,
    createTicketTag,
    deleteTicketTag,
    getTicketTagCount,
  }
})
